import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// import * as modals from 'web/components/common/modal';
import LoginContainer from 'web/containers/modal/LoginContainer';
import JoinContainer from 'web/containers/modal/JoinContainer';
import FindEmailContainer from 'web/containers/modal/FindEmailContainer';
import FindPasswordContainer from 'web/containers/modal/FindPasswordContainer';
import PasswordChangeContainer from 'web/containers/modal/PasswordChangeContainer';
import VertifyPhoneContainer from 'web/containers/modal/VertifyPhoneContainer';
import DeviceListContainer from 'web/containers/modal/DeviceListContainer';
import DropOutCheckContainer from 'web/containers/modal/DropOutCheckContainer';
import TeacherInterviewContainer from 'web/containers/modal/TeacherInterviewContainer';
import AlertContainer from 'web/containers/modal/AlertContainer';
import EZPenDetailContainer from 'web/containers/modal/EZPenDetailContainer';
import EZPenDetailMobileContainer from 'web/containers/modal/EZPenDetailMobileContainer';
import AiDetailContainer from 'web/containers/modal/AiDetailContainer';
import AiDetailMobileContainer from 'web/containers/modal/AiDetailMobileContainer';
import AdviceContainer from 'web/containers/modal/AdviceContainer';
import VideoPlayerContainer from 'web/containers/modal/VideoPlayerContainer';
import ConsultingContainer from 'web/containers/modal/ConsultingContainer';
import ReviewContainer from 'web/containers/modal/ReviewContainer';
import ReviewMobileContainer from 'web/containers/modal/ReviewMobileContainer';
import PolicyContainer from 'web/containers/modal/PolicyContainer';
import UsallyDetailContainer from 'web/containers/modal/UsallyDetailContainer';
import ThoundsSongsContainer from 'web/containers/modal/ThoundsSongsContainer';
import ChallengeStartContainer from 'web/containers/modal/ChallengeStartContainer';
import DisconnectContainer from 'web/containers/modal/DisconnectContainer';
import LoadingContainer from 'web/containers/modal/LoadingContainer';
import EventPopupContainer from 'web/containers/modal/EventPopupContainer';
import NsdaCuponCompleteContainer from 'web/containers/modal/NsdaCuponCompleteContainer';
import NewReviewContainer from 'shared/containers/selling/NewReviewContainer';
import BookEasyPenContainer from 'web/containers/modal/BookEasyPenContainer';
import AiPackageContainer from 'web/containers/modal/AiPackageContainer';
import CourseRegisterContainer from 'shared/containers/main/CourseRegisterContainer';
import CouponContainer from 'shared/containers/coupon/CouponContainer';
import CouponSuccessContainer from 'shared/containers/coupon/CouponSuccessContainer';
import MarketingAgreeContainer from 'web/containers/modal/MarketingAgreeContainer';
import AirPodContainer from 'web/containers/modal/AirPodContainer';
import AirPodDetailContainer from 'web/containers/modal/AirPodDetailContainer';
import EasyPenDetailContainer from 'web/containers/modal/EasyPenDetailContainer';
import GoSellingPageContainer from 'shared/containers/selling/GoSellingPageContainer';
import VideoPageContainer from 'shared/containers/video/VideoPageContainer';
import { initModal, pushModal } from 'shared/actions/modal.action';
import GoToRealclass from 'web/containers/modal/GoToRealclass';
import SignupInRealclass from 'web/containers/modal/SignupInRealclass';
import TeacherInfoContainer from './TeacherInfoContainer';

import PackageContainer from './PackageContainer';
import ScholarContainer from './ScholarContainer';
import AiOkayDoctorContainer from './AiOkayDoctorContainer';

@withRouter
@connect(
  state => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  { initModal, pushModal },
)
class LayoutContainer extends Component {
  handlePopup = (type, payload) => {
    // console.log(`handlePopup - ${type}`);
    return this.props.pushModal({ type, data: payload });
  };

  handleRedirect = () => {
    const { pathname } = this.props.location;
    const splitPath = pathname.split('/');

    // console.log({ pathname, splitPath });

    switch (splitPath[1]) {
      case 'study':
        if (splitPath[2]) {
          this.props.history.push(`/study/${splitPath[2]}/detail`);
        }
        return;

      default:
        return;
    }
  };

  render() {
    const { modal = {} } = this.props;
    const { data } = modal;

    const popupHandler = {
      login: (payload = {}) => {
        const { username } = payload;
        return this.handlePopup('Login', { username });
      },
      join: () => this.handlePopup('SignupInRealclass'),
      findEmail: () => this.handlePopup('FindEmail'),
      findPassword: () => this.handlePopup('FindPassword'),
      // hasEmail: () => this.handlePopup('HasEmail'),
      close: () => {
        this.handleRedirect();
        this.props.initModal();
      },
    };

    // console.log(modal.type);

    let md = null;
    switch (modal.type) {
      case 'Login':
        md = (
          <LoginContainer
            popupHandler={popupHandler}
            history={this.props.history}
            location={this.props.location}
          />
        );
        break;
      case 'Join':
        md = (
          <JoinContainer
            popupHandler={popupHandler}
            location={this.props.location}
            history={this.props.history}
          />
        );
        break;
      case 'FindEmail':
        md = <FindEmailContainer popupHandler={popupHandler} />;
        break;
      case 'FindPassword':
        md = <FindPasswordContainer popupHandler={popupHandler} />;
        break;
      case 'VertifyPhone':
        md = <VertifyPhoneContainer popupHandler={popupHandler} />;
        break;
      case 'PasswordChange':
        md = <PasswordChangeContainer popupHandler={popupHandler} />;
        break;
      // case 'Consultation':
      //   md = <ConsultationContainer popupHandler={popupHandler} />;
      //   break;
      case 'Consultation':
        md = <CourseRegisterContainer popupHandler={popupHandler} />;
        break;
      case 'DeviceList':
        md = <DeviceListContainer popupHandler={popupHandler} />;
        break;
      case 'DropOutCheck':
        md = <DropOutCheckContainer popupHandler={popupHandler} />;
        break;
      case 'TeacherInterview':
        md = <TeacherInterviewContainer popupHandler={popupHandler} />;
        break;
      case 'Alert':
        md = <AlertContainer popupHandler={popupHandler} />;
        break;
      case 'EZPenDetail':
        md = <EZPenDetailContainer popupHandler={popupHandler} />;
        break;
      case 'EZPenDetailMobile':
        md = <EZPenDetailMobileContainer popupHandler={popupHandler} />;
        break;
      case 'AiDetail':
        md = <AiDetailContainer popupHandler={popupHandler} />;
        break;
      case 'AiDetailMobile':
        md = <AiDetailMobileContainer popupHandler={popupHandler} />;
        break;
      case 'AdviceRequest':
        md = <AdviceContainer popupHandler={popupHandler} />;
        break;
      // case 'lectureMusicVideo':
      //   md = <LectureFirstOpenContainer popupHandler={popupHandler} />;
      //   break;

      case 'VideoPlayer':
        md = <VideoPlayerContainer popupHandler={popupHandler} />;
        break;
      case 'Consulting':
        md = <ConsultingContainer popupHandler={popupHandler} />;
        break;
      case 'ReviewModal':
        md = <ReviewContainer popupHandler={popupHandler} />;
        break;
      case 'ReviewModalMobile':
        md = <ReviewMobileContainer popupHandler={popupHandler} />;
        break;
      case 'Policy':
        md = <PolicyContainer popupHandler={popupHandler} />;
        break;
      case 'UsallyDetail':
        md = <UsallyDetailContainer popupHandler={popupHandler} />;
        break;
      case 'TeacherInfo':
        md = <TeacherInfoContainer popupHandler={popupHandler} />;
        break;
      case 'Disconnect':
        md = <DisconnectContainer popupHandler={popupHandler} />;
        break;
      case 'thounds':
        md = <ThoundsSongsContainer popupHandler={popupHandler} />;
        break;
      case 'challengestart':
        md = <ChallengeStartContainer popupHandler={popupHandler} />;
        break;
      case 'Loading':
        md = <LoadingContainer popupHandler={popupHandler} />;
        break;
      case 'EventPopupContainer':
        md = <EventPopupContainer popupHandler={popupHandler} />;
        break;
      case 'NsdaCuponCompleteContainer':
        md = <NsdaCuponCompleteContainer popupHandler={popupHandler} />;
        break;
      case 'NewReviewContainer':
        md = <NewReviewContainer popupHandler={popupHandler} />;
        break;
      case 'BookEasyPenContainer':
        md = <BookEasyPenContainer popupHandler={popupHandler} />;
        break;
      case 'PackageContainer':
        md = <PackageContainer popupHandler={popupHandler} />;
        break;
      case 'ScholarContainer':
        md = <ScholarContainer popupHandler={popupHandler} />;
        break;
      case 'AiPackageContainer':
        md = <AiPackageContainer popupHandler={popupHandler} />;
        break;
      case 'CourseRegisterContainer':
        md = <CourseRegisterContainer popupHandler={popupHandler} />;
        break;
      case 'CouponContainer':
        md = <CouponContainer popupHandler={popupHandler} data={data} />;
        break;
      case 'CouponSuccessContainer':
        md = (
          <CouponSuccessContainer
            popupHandler={popupHandler}
            history={this.props.history}
          />
        );
        break;
      case 'MarketingAgreeContainer':
        md = <MarketingAgreeContainer popupHandler={popupHandler} />;
        break;
      case 'AirPod':
        md = <AirPodContainer popupHandler={popupHandler} />;
        break;
      case 'AirPodDetail':
        md = <AirPodDetailContainer popupHandler={popupHandler} />;
        break;
      case 'EasyPenDetail':
        md = <EasyPenDetailContainer popupHandler={popupHandler} />;
        break;
      case 'AiOkayDoctorDetail':
        md = <AiOkayDoctorContainer popupHandler={popupHandler} />;
        break;
      case 'goSelling':
        md = (
          <GoSellingPageContainer
            popupHandler={popupHandler}
            history={this.props.history}
          />
        );
        break;

      case 'VideoPlaying':
        md = <VideoPageContainer data={data} history={this.props.history} />;
        break;

      case 'GoToRealclass':
        md = <GoToRealclass popupHandler={popupHandler} />;
        break;

      case 'SignupInRealclass':
        md = <SignupInRealclass popupHandler={popupHandler} />;
        break;

      default:
        md = <></>;
        break;
    }

    return <>{md}</>;
  }
}

export default LayoutContainer;
